import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule, DatePipe, TitleCasePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AvatarModule } from '@michaeleckhartwoellkart/ngx-avatars';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FilterReasonMapsComponent } from '@shared/components/filter-reason-maps/filter-reason-maps.component';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { ColorPickerComponent as ColorPickerComponentNgx, ColorPickerDirective } from 'ngx-color-picker';
import { NgxDaterangepickerBootstrapModule } from 'ngx-daterangepicker-bootstrap';
import { NgxGaugeModule } from 'ngx-gauge';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { QuillModule } from 'ngx-quill';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { OverlayscrollbarsModule } from 'overlayscrollbars-ngx';
import { HttpInterceptorService } from '../core/services/http-interceptor.service';
import { RetryInterceptor } from '../core/services/retry-interceptor.service';
import { RoomContainerComponent } from '../operatingschedule/surgeon/room-container/room-container.component';
import { MyProgramHebdoComponent } from '../smart-planning/my-program/my-program-hebdo/my-program-hebdo.component';
import { MyProgramMonthlyComponent } from '../smart-planning/my-program/my-program-monthly/my-program-monthly.component';
import { MyProgramPopupComponent } from '../smart-planning/my-program/my-program-popup/my-program-popup.component';
import { WeekVuePopupComponent } from '../smart-planning/week-vue/week-vue-popup/week-vue-popup.component';
import { ActsSurgeonComponent } from './components/acts-surgeon/acts-surgeon.component';
import { AddChannelPopupComponent } from './components/add-channel-popup/add-channel-popup.component';
import { AddEditSpecialtyComponent } from './components/add-edit-specialty/add-edit-specialty.component';
import { AddIndicatorsPopupComponent } from './components/add-indicators-popup/add-indicators-popup.component';
import { AddProfileDialogComponent } from './components/add-profile-dialog/add-profile-dialog.component';
import { AddProfileComponent } from './components/add-profile/add-profile.component';
import { AddReasonDialogComponent } from './components/add-reason-dialog/add-reason-dialog.component';
import { AddSurgeonDialogComponent } from './components/add-surgeon-dialog/add-surgeon-dialog.component';
import { AddSurgeonComponent } from './components/add-surgeon/add-surgeon.component';
import { AddUserComponent } from './components/add-user/add-user.component';
import { addVacationHrsuitePopupComponent } from './components/add-vacation-hrsuite/add-vacation-hrsuite-popup.component';
import { AddVacationPopupComponent } from './components/add-vacation-popup/add-vacation-popup.component';
import { AddValidateRulesDialogComponent } from './components/add-validate-rules-dialog/add-validate-rules-dialog.component';
import { AdjustPlanningPopupComponent } from './components/adjust-planning-popup/adjust-planning-popup.component';
import { AnnuairePopupComponent } from './components/annuaire-popup/annuaire-popup.component';
import { AutofillingPopupComponent } from './components/autofilling-popup/autofilling-popup.component';
import { AvailabilityLegendsComponent } from './components/availability-legends/availability-legends.component';
import { AvatarsTooltipComponent } from './components/avatars-tooltip/avatars-tooltip.component';
import { BasicProfileComponent } from './components/basic-profile/basic-profile.component';
import { BoxExchangeComponent } from './components/box-exchange/box-exchange.component';
import { BufferTableComponent } from './components/buffer-table/buffer-table.component';
import { ButtonComponent } from './components/button/button.component';
import { ButtonsFloatingComponent } from './components/buttons-floating-component/buttons-floating-component.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { CheckboxGroupComponent } from './components/checkbox-group/checkbox-group.component';
import { CodeRHBadgeComponent } from './components/code-rh-badge/code-rh-badge.component';
import { ColorPickerComponent } from './components/color-picker/color-picker.component';
import { ColumnSelectorModalComponent } from './components/columns-selector/columns-selector.component';
import { ConfigPopupComponent } from './components/config-popup/config-popup.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { ConfirmationPopupComponent } from './components/confirmation-popup/confirmation-popup.component';
import { CreateCampaignPopupComponent } from './components/create-campaign-popup/create-campaign-popup.component';
import { DetailCheckCampaignPopupComponent } from './components/create-campaign-popup/detail-check-campaign-popup/detail-check-campaign-popup.component';
import { CreateCycleDialogComponent } from './components/create-cycle-dialog/create-cycle-dialog.component';
import { CreatePopulationComponent } from './components/create-population/create-population.component';
import { CustomDatePickerNormalComponent } from './components/custom-date-picker-normal/custom-date-picker-normal.component';
import { CustomDatePickerSmallComponent } from './components/custom-date-picker-small/custom-date-picker-small.component';
import { CustomDatePickerWeekComponent } from './components/custom-date-picker-week/custom-date-picker-week.component';
import { DateInputComponent } from './components/date-input/date-input.component';
import { DatePickerShowWeekComponent } from './components/date-picker-show-week/date-picker-show-week.component';
import { ShowWeekCountHeaderComponent } from './components/date-picker-show-week/show-week-count-header/show-week-count-header.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { DayAvailabilityOfSurgeonComponent } from './components/day-availability-of-surgeon/day-availability-of-surgeon.component';
import { DayAvailabilityComponent } from './components/day-availability/day-availability.component';
import { DayEventComponent } from './components/day-event/day-event.component';
import { AnesthWeekPopupComponent } from './components/day-program-recap/anesth-week-popup/anesth-week-popup.component';
import { AvailableProfilesComponent } from './components/day-program-recap/available-profiles/available-profiles.component';
import { DataColumnComponent } from './components/day-program-recap/data-column/data-column.component';
import { DataDetailPopupComponent } from './components/day-program-recap/data-detail-popup/data-detail-popup.component';
import { DayProgramRecapComponent } from './components/day-program-recap/day-program-recap.component';
import { PopupRoleSkillDetailsComponent } from './components/day-program-recap/popup-role-skill-details/popup-role-skill-details.component';
import { SplitAllRoomsPopupComponent } from './components/day-program-recap/split-all-rooms-popup/split-all-rooms-popup.component';
import { TeamCardsComponent } from './components/day-program-recap/team-cards/team-cards.component';
import { DefaultPopupComponent } from './components/default-popup/default-popup.component';
import { DeleteIconComponent } from './components/delete-icon/delete-icon.component';
import { DisponibilityDialogComponent } from './components/disponibility-dialog/disponibility-dialog.component';
import { DocumentReaderPopupComponent } from './components/document-reader-popup/document-reader-popup.component';
import { DoghnutChartComponent } from './components/doghnut-chart/doghnut-chart.component';
import { DropdownMenuComponent } from './components/dropdown-menu/dropdown-menu.component';
import { CropperPopupComponent } from './components/edit-personal-data/cropper-popup/cropper-popup.component';
import { EditPersonalDataComponent } from './components/edit-personal-data/edit-personal-data.component';
import { EffectiveNeedsDetailsPopupComponent } from './components/effective-needs/effective-needs-details-popup/effective-needs-details-popup.component';
import { EffectiveNeedsComponent } from './components/effective-needs/effective-needs.component';
import { ExchangePopupComponent } from './components/exchange-popup/exchange-popup.component';
import { ExitDialogComponent } from './components/exit-dialog/exit-dialog.component';
import { ExportDayComponent } from './components/export-day-popup/export-day-popup.component';
import { ExportNurseReportPopupComponent } from './components/export-nurse-report-popup/export-nurse-report-popup.component';
import { ExportPageSizeDialogComponent } from './components/export-page-size-dialog/export-page-size-dialog.component';
import { FeedAllRoomsVueComponent } from './components/feed-all-rooms-vue/feed-all-rooms-vue.component';
import { HoursPopupComponent } from './components/feed-all-rooms-vue/hours-popup/hours-popup.component';
import { MoveInterventionPopupComponent } from './components/feed-all-rooms-vue/move-intervention-popup/move-intervention-popup.component';
import { AddEditExclusionComponent } from './components/fiche-poste/add-edit-exclusion/add-edit-exclusion.component';
import { AddEditLissageComponent } from './components/fiche-poste/add-edit-lissage/add-edit-lissage.component';
import { AddEditRecurrenceComponent } from './components/fiche-poste/add-edit-recurrence/add-edit-recurrence.component';
import { AddEditRuleComponent } from './components/fiche-poste/add-edit-rule/add-edit-rule.component';
import { AddEditRule2Component } from './components/fiche-poste/add-edit-rule2/add-edit-rule2.component';
import { AddWishPopupComponent } from './components/fiche-poste/add-wish-popup/add-wish-popup.component';
import { DiffuseConstraintPopupComponent } from './components/fiche-poste/diffuse-constraint-popup/diffuse-constraint-popup.component';
import { EditWishPopupComponent } from './components/fiche-poste/edit-wish-popup/edit-wish-popup.component';
import { FichePosteComponent } from './components/fiche-poste/fiche-poste.component';
import { ForDisplayPopupComponent } from './components/fiche-poste/for-display-popup/for-display-popup.component';
import { FilterPopupComponent } from './components/filter-popup/filter-popup.component';
import { GardeTableComponent } from './components/garde-table/garde-table.component';
import { GroupedRhValidationDialogComponent } from './components/grouped-rh-validation-dialog/grouped-rh-validation-dialog.component';
import { HeaderComponent } from './components/header/app-header.component';
import { HospitalsHoverComponent } from './components/hospitals-hover/hospitals-hover.component';
import { HoursInputComponent } from './components/hours-input/hours-input.component';
import { ImagePickerComponent } from './components/image-picker/image-picker.component';
import { ImportProfileDialogComponent } from './components/import-profile-dialog/import-profile-dialog.component';
import { InterventionDetailPanelComponent } from './components/intervention-detail-panel/intervention-detail-panel.component';
import { InterventionDetailsPopupComponent } from './components/intervention-details-popup/intervention-details-popup.component';
import { InterventionPopupComponent } from './components/intervention-popup/intervention-popup.component';
import { InterventionInfDialogComponent } from './components/interventions-inf-dialog/intervention-inf-dialog.component';
import { InterventionsInfComponent } from './components/interventions-inf/interventions-inf.component';
import { IntializeProfileSkillsComponent } from './components/intialize-profile-skills/intialize-profile-skills.component';
import { LegendComponent } from './components/legend/legend.component';
import { LogsSidenavComponent } from './components/logs-sidenav/logs-sidenav.component';
import { MessageComponent } from './components/message/message.component';
import { NotificationsFeedComponent } from './components/notifications-feed/notifications-feed.component';
import { ObjectifStatusComponent } from './components/objectif-status/objectif-status.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { PasswordCheckerComponent } from './components/password-checker/password-checker.component';
import { PersonToExchangeComponent } from './components/person-to-exchange/person-to-exchange.component';
import { PopupAvailalabilityRequestInfosComponent } from './components/popup-availalability-request-infos/popup-availalability-request-infos.component';
import { PopupEditVacationComponent } from './components/popup-edit-vacation/popup-edit-vacation.component';
import { PopupExportStaffComponent } from './components/popup-export-staff/popup-export-staff.component';
import { ImportCalendarsPopupComponent } from './components/popup-import-calendars/popup-import-calendars.component';
import { ImportDataPopupComponent } from './components/popup-import-data/popup-import-data.component';
import { ImportRealProgramsPopupComponent } from './components/popup-import-real-programs/popup-import-real-programs.component';
import { PopupRoomInterventionFilterComponent } from './components/popup-room-intervention-filter/popup-room-intervention-filter.component';
import { PopupSelectHospitalComponent } from './components/popup-select-hospital/popup-select-hospital.component';
import { PopupSwitchRequestInfosComponent } from './components/popup-switch-request-infos/popup-switch-request-infos.component';
import { ProfilesListPopupComponent } from './components/profiles-list-popup/profiles-list-popup.component';
import { ProfilesPickerDialogComponent } from './components/profiles-picker-dialog/profiles-picker-dialog.component';
import { ProfilesSelectionGenerationComponent } from './components/profiles-selection-generation/profiles-selection-generation.component';
import { ProfilesSelectionComponent } from './components/profiles-selection/profiles-selection.component';
import { ProfilesSuggestionsComponent } from './components/profiles-suggestions/profiles-suggestions.component';
import { ProgressBarSharedComponent } from './components/progress-bar-shared/progress-bar-shared.component';
import { RadioButtonGroupComponent } from './components/radio-button-group/radio-button-group.component';
import { RangeDatePickerModule } from './components/range-date-picker/date-range-picker.module';
import { ReadInPopupComponent } from './components/read-in-popup/read-in-popup.component';
import { RefuseReasonDialogComponent } from './components/refuse-reason-dialog/refuse-reason-dialog.component';
import { RelaunchAvailabilityComponent } from './components/relaunch-availability/relaunch-availability.component';
import { ResetPasswordFormComponent } from './components/reset-password-form/reset-password-form.component';
import { RoomDoctorAgendaComponent } from './components/room-doctor-agenda/room-doctor-agenda.component';
import { InterventionCardComponent } from './components/intervention-card/intervention-card.component';
import { RoomStatsComponent } from './components/room-stats/room-stats.component';
import { RoomOverviewComponent } from './components/room-overview/room-overview.component';
import { RoomCondensedOverviewComponent } from './components/room-condensed-overview/room-condensed-overview.component';
import { RoomDetailDialogComponent } from './components/room-detail-dialog/room-detail-dialog.component';
import { SearchActBarComponent } from './components/search-act-bar/search-act-bar.component';
import { SearchBarExtracliniqueComponent } from './components/search-bar-extraclinique/search-bar-extraclinique.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { SelectRoomsPopupComponent } from './components/select-rooms/select-rooms-popup.component';
import { SliderInputComponent } from './components/slider-input/slider-input.component';
import { SmartOpAvatarComponent } from './components/smart-op-avatar/smart-op-avatar.component';
import { SpecialtiesHoverComponent } from './components/specialties-hover/specialties-hover.component';
import { SpiderChartComponent } from './components/spider-chart/spider-chart.component';
import { SurgeonFeedAvatarComponent } from './components/surgeon-feed-avatar/surgeon-feed-avatar.component';
import { SurgeonOpeningComponent } from './components/surgeon-opening/surgeon-opening.component';
import { SurgeonsDistributionTooltipComponent } from './components/surgeons-distribution-tooltip/surgeons-distribution-tooltip.component';
import { TextInputComponent } from './components/text-input/text-input.component';
import { TextareaComponent } from './components/textarea/textarea.component';
import { ToggleSwitchComponent } from './components/toggle-switch/toggle-switch.component';
import { ToggleComponent } from './components/toggle/app-toggle.component';
import { VimeoComponent } from './components/vimeo/vimeo.component';
import { WeekAvailabilitesOfSurgeonComponent } from './components/week-availabilites-of-surgeon/week-availabilites-of-surgeon.component';
import { WeekAvailabilitiesComponent } from './components/week-availabilities/week-availabilities.component';
import { WeeklyProgramConfigurationPopupComponent } from './components/weekly-program-configuration-popup/weekly-program-configuration-popup.component';
import { MaterialModule } from './material.module';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { SentenceCasePipe } from './pipes/sentence-case.pipe';
import { CastToPipe } from './pipes/cast-to.pipe';
import { TimePipe } from './pipes/time.pipe';
import { DateToTimePipe } from './pipes/date-to-time.pipe';
import { FilterSpecialties } from './pipes/filterSpecialties.pipe';
import { FindDaysPipe } from './pipes/find-days.pipe';
import { FormControlPipe } from './pipes/form-control.pipe';
import { FormatHourMinPipe } from './pipes/format-hour-min.pipe';
import { FormatMessageConfirmationPopupPipe } from './pipes/format-message-confirmation-popup.pipe';
import { FormatSeniorityPipe } from './pipes/format-seniority.pipe';
import { FormatTimePipe } from './pipes/format-time.pipe';
import { isNaNPipe } from './pipes/isNaN.pipe';
import { FloorPipe } from './pipes/math-floor.pipe';
import { RoundPipe } from './pipes/math-round.pipe';
import { SafeUrlPipe } from './pipes/safeUrl.pipe';
import { toIADEPipe } from './pipes/toIADE.pipe';
import { TranslatePipe } from './pipes/translate.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { NurseCycleService } from './services/nurse-cycle.service';
import { EllipsisSwapDirective } from './utils/ellipsisSwap.directive';
import { EllipsisTooltipDirective } from './utils/ellipsis-tooltip.directive';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CodeRhSwapComponent } from './components/code-rh-swap/code-rh-swap.component';
import { MetricTileComponent } from '@shared/components/metric-tile/metric-tile.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { DocumentationDialogComponent } from '@shared/components/documentation-dialog/documentation-dialog.component';
import { HighlightSearchPipe } from './pipes/highlight-search.pipe';
import { PopulationDetailsPopupComponent } from './components/population-details-popup/population-details-popup.component';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { OnboardingComponent } from './components/onboarding/onboarding.component';

@NgModule({
  declarations: [
    OnboardingComponent,
    CodeRhSwapComponent,
    EllipsisSwapDirective,
    EllipsisTooltipDirective,
    CapitalizePipe,
    SentenceCasePipe,
    CastToPipe,
    TimePipe,
    DateToTimePipe,
    FilterSpecialties,
    FormatHourMinPipe,
    FormatMessageConfirmationPopupPipe,
    FormatSeniorityPipe,
    FormatTimePipe,
    isNaNPipe,
    FindDaysPipe,
    RoundPipe,
    FloorPipe,
    SafeUrlPipe,
    toIADEPipe,
    TranslatePipe,
    HighlightSearchPipe,
    TruncatePipe,
    FormControlPipe,
    ButtonComponent,
    PopupSelectHospitalComponent,
    PopupRoomInterventionFilterComponent,
    EffectiveNeedsComponent,
    EffectiveNeedsDetailsPopupComponent,
    SpiderChartComponent,
    PopupRoleSkillDetailsComponent,
    ObjectifStatusComponent,
    DefaultPopupComponent,
    DatePickerComponent,
    TextInputComponent,
    DateInputComponent,
    RadioButtonGroupComponent,
    ImagePickerComponent,
    PasswordCheckerComponent,
    ChangePasswordComponent,
    EditPersonalDataComponent,
    CropperPopupComponent,
    ResetPasswordFormComponent,
    ConfirmDialogComponent,
    ExitDialogComponent,
    PopupAvailalabilityRequestInfosComponent,
    PopupSwitchRequestInfosComponent,
    SmartOpAvatarComponent,
    HospitalsHoverComponent,
    SpecialtiesHoverComponent,
    NotificationsFeedComponent,
    AnnuairePopupComponent,
    AddChannelPopupComponent,
    CheckboxGroupComponent,
    ToggleComponent,
    MessageComponent,
    SearchBarComponent,
    CustomDatePickerNormalComponent,
    CustomDatePickerSmallComponent,
    CustomDatePickerWeekComponent,
    AddEditExclusionComponent,
    AddEditLissageComponent,
    AddEditRecurrenceComponent,
    DatePickerShowWeekComponent,
    ShowWeekCountHeaderComponent,
    AddEditRuleComponent,
    AddEditRule2Component,
    AddWishPopupComponent,
    DiffuseConstraintPopupComponent,
    EditWishPopupComponent,
    ForDisplayPopupComponent,
    FichePosteComponent,
    DropdownMenuComponent,
    ButtonsFloatingComponent,
    AddProfileDialogComponent,
    AddProfileComponent,
    ImportProfileDialogComponent,
    IntializeProfileSkillsComponent,
    addVacationHrsuitePopupComponent,
    LegendComponent,
    RelaunchAvailabilityComponent,
    CreatePopulationComponent,
    ImportCalendarsPopupComponent,
    ToggleSwitchComponent,
    DayEventComponent,
    WeekAvailabilitiesComponent,
    DayAvailabilityComponent,
    DisponibilityDialogComponent,
    HoursInputComponent,
    ExchangePopupComponent,
    ExportNurseReportPopupComponent,
    TextareaComponent,
    PersonToExchangeComponent,
    BoxExchangeComponent,
    SearchBarExtracliniqueComponent,
    AvailabilityLegendsComponent,
    ConfigPopupComponent,
    MyProgramPopupComponent,
    MyProgramMonthlyComponent,
    MyProgramHebdoComponent,
    WeeklyProgramConfigurationPopupComponent,
    WeekVuePopupComponent,
    PaginationComponent,
    DayProgramRecapComponent,
    AutofillingPopupComponent,
    ExportDayComponent,
    ExportPageSizeDialogComponent,
    TeamCardsComponent,
    DeleteIconComponent,
    SplitAllRoomsPopupComponent,
    DataDetailPopupComponent,
    RoomContainerComponent,
    ProfilesSuggestionsComponent,
    DataColumnComponent,
    AvailableProfilesComponent,
    AnesthWeekPopupComponent,
    GardeTableComponent,
    BufferTableComponent,
    ProgressBarSharedComponent,
    CreateCampaignPopupComponent,
    DetailCheckCampaignPopupComponent,
    HeaderComponent,
    GroupedRhValidationDialogComponent,
    RefuseReasonDialogComponent,
    ReadInPopupComponent,
    AddSurgeonDialogComponent,
    AddSurgeonComponent,
    InterventionInfDialogComponent,
    SurgeonOpeningComponent,
    WeekAvailabilitesOfSurgeonComponent,
    DayAvailabilityOfSurgeonComponent,
    DoghnutChartComponent,
    BasicProfileComponent,
    SurgeonsDistributionTooltipComponent,
    ProfilesListPopupComponent,
    InterventionsInfComponent,
    ActsSurgeonComponent,
    AddIndicatorsPopupComponent,
    ImportRealProgramsPopupComponent,
    ColumnSelectorModalComponent,
    DocumentReaderPopupComponent,
    SearchActBarComponent,
    AvatarsTooltipComponent,
    AddUserComponent,
    AddEditSpecialtyComponent,
    AddReasonDialogComponent,
    ColorPickerComponent,
    AddValidateRulesDialogComponent,
    SliderInputComponent,
    ProfilesSelectionComponent,
    ProfilesSelectionGenerationComponent,
    ConfirmationPopupComponent,
    ProfilesPickerDialogComponent,
    VimeoComponent,
    FilterPopupComponent,
    ImportDataPopupComponent,
    SelectRoomsPopupComponent,
    InterventionPopupComponent,
    RoomDoctorAgendaComponent,
    InterventionCardComponent,
    RoomStatsComponent,
    RoomOverviewComponent,
    RoomCondensedOverviewComponent,
    RoomDetailDialogComponent,
    SurgeonFeedAvatarComponent,
    FeedAllRoomsVueComponent,
    InterventionDetailPanelComponent,
    InterventionDetailsPopupComponent,
    AddVacationPopupComponent,
    MoveInterventionPopupComponent,
    HoursPopupComponent,
    CreateCycleDialogComponent,
    CodeRHBadgeComponent,
    PopupEditVacationComponent,
    LogsSidenavComponent,
    FilterReasonMapsComponent,
    AdjustPlanningPopupComponent,
    PopupExportStaffComponent,
    MetricTileComponent,
    DocumentationDialogComponent,
    PopulationDetailsPopupComponent,
  ],
  imports: [
    MatAutocomplete,
    MatInputModule,
    NgxSkeletonLoaderModule,
    CommonModule,
    FlexLayoutModule,
    MaterialModule,
    FormsModule,
    AvatarModule,
    ReactiveFormsModule,
    ImageCropperComponent,
    OverlayscrollbarsModule,
    PortalModule,
    QuillModule.forRoot({
      placeholder: '',
    }),
    ScrollingModule,
    DragDropModule,
    NgxMaterialTimepickerModule,
    PdfJsViewerModule,
    ColorPickerComponentNgx,
    ColorPickerDirective,
    NgxGaugeModule,
    RangeDatePickerModule,
    NgxDaterangepickerBootstrapModule,
    OverlayModule,
  ],
  providers: [
    DatePipe,
    TitleCasePipe,
    FormatMessageConfirmationPopupPipe,
    FormatSeniorityPipe,
    NurseCycleService,
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RetryInterceptor,
      multi: true,
    },
  ],
  exports: [
    OnboardingComponent,
    CodeRhSwapComponent,
    EllipsisSwapDirective,
    EllipsisTooltipDirective,
    CapitalizePipe,
    SentenceCasePipe,
    CastToPipe,
    TimePipe,
    DateToTimePipe,
    FilterSpecialties,
    FormatHourMinPipe,
    FormatMessageConfirmationPopupPipe,
    FormatSeniorityPipe,
    FormatTimePipe,
    isNaNPipe,
    FindDaysPipe,
    RoundPipe,
    FloorPipe,
    SafeUrlPipe,
    toIADEPipe,
    TranslatePipe,
    HighlightSearchPipe,
    TruncatePipe,
    FormControlPipe,
    FlexLayoutModule,
    ButtonComponent,
    PopupSelectHospitalComponent,
    PopupRoomInterventionFilterComponent,
    MaterialModule,
    FormsModule,
    EffectiveNeedsComponent,
    ObjectifStatusComponent,
    DatePickerComponent,
    TextInputComponent,
    ReactiveFormsModule,
    DateInputComponent,
    RadioButtonGroupComponent,
    ImagePickerComponent,
    PasswordCheckerComponent,
    ChangePasswordComponent,
    EditPersonalDataComponent,
    CropperPopupComponent,
    ResetPasswordFormComponent,
    ConfirmDialogComponent,
    ExitDialogComponent,
    PopupAvailalabilityRequestInfosComponent,
    PopupSwitchRequestInfosComponent,
    SmartOpAvatarComponent,
    HospitalsHoverComponent,
    SpecialtiesHoverComponent,
    NotificationsFeedComponent,
    OverlayscrollbarsModule,
    PortalModule,
    AnnuairePopupComponent,
    QuillModule,
    AddChannelPopupComponent,
    CheckboxGroupComponent,
    ToggleComponent,
    MessageComponent,
    SearchBarComponent,
    ScrollingModule,
    DragDropModule,
    CustomDatePickerNormalComponent,
    CustomDatePickerSmallComponent,
    CustomDatePickerWeekComponent,
    DatePickerShowWeekComponent,
    ShowWeekCountHeaderComponent,
    FichePosteComponent,
    DropdownMenuComponent,
    ButtonsFloatingComponent,
    AddProfileDialogComponent,
    AddProfileComponent,
    ImportProfileDialogComponent,
    IntializeProfileSkillsComponent,
    addVacationHrsuitePopupComponent,
    LegendComponent,
    RelaunchAvailabilityComponent,
    CreatePopulationComponent,
    ImportCalendarsPopupComponent,
    ToggleSwitchComponent,
    DayEventComponent,
    WeekAvailabilitiesComponent,
    DayAvailabilityComponent,
    DisponibilityDialogComponent,
    HoursInputComponent,
    NgxMaterialTimepickerModule,
    ExchangePopupComponent,
    ExportNurseReportPopupComponent,
    TextareaComponent,
    PersonToExchangeComponent,
    BoxExchangeComponent,
    SearchBarExtracliniqueComponent,
    AvailabilityLegendsComponent,
    ConfigPopupComponent,
    MyProgramPopupComponent,
    MyProgramMonthlyComponent,
    AvatarModule,
    MyProgramHebdoComponent,
    WeeklyProgramConfigurationPopupComponent,
    WeekVuePopupComponent,
    PaginationComponent,
    DayProgramRecapComponent,
    AutofillingPopupComponent,
    ExportDayComponent,
    ExportPageSizeDialogComponent,
    TeamCardsComponent,
    DeleteIconComponent,
    SplitAllRoomsPopupComponent,
    DataDetailPopupComponent,
    RoomContainerComponent,
    ProfilesSuggestionsComponent,
    DataColumnComponent,
    AvailableProfilesComponent,
    AnesthWeekPopupComponent,
    GardeTableComponent,
    BufferTableComponent,
    ProgressBarSharedComponent,
    CreateCampaignPopupComponent,
    DetailCheckCampaignPopupComponent,
    HeaderComponent,
    GroupedRhValidationDialogComponent,
    RefuseReasonDialogComponent,
    ReadInPopupComponent,
    AddSurgeonDialogComponent,
    AddSurgeonComponent,
    InterventionInfDialogComponent,
    SurgeonOpeningComponent,
    WeekAvailabilitesOfSurgeonComponent,
    DayAvailabilityOfSurgeonComponent,
    DoghnutChartComponent,
    BasicProfileComponent,
    NgxSkeletonLoaderModule,
    ProfilesListPopupComponent,
    SurgeonsDistributionTooltipComponent,
    InterventionsInfComponent,
    ActsSurgeonComponent,
    AddIndicatorsPopupComponent,
    ImportRealProgramsPopupComponent,
    ColumnSelectorModalComponent,
    DocumentReaderPopupComponent,
    CommonModule,
    SearchActBarComponent,
    AvatarsTooltipComponent,
    AddUserComponent,
    AddEditSpecialtyComponent,
    AddReasonDialogComponent,
    ColorPickerComponent,
    AddValidateRulesDialogComponent,
    SliderInputComponent,
    ProfilesSelectionComponent,
    ProfilesSelectionGenerationComponent,
    ConfirmationPopupComponent,
    ProfilesPickerDialogComponent,
    VimeoComponent,
    FilterPopupComponent,
    ImportDataPopupComponent,
    SelectRoomsPopupComponent,
    InterventionPopupComponent,
    RoomDoctorAgendaComponent,
    InterventionCardComponent,
    RoomStatsComponent,
    RoomOverviewComponent,
    RoomCondensedOverviewComponent,
    RoomDetailDialogComponent,
    SurgeonFeedAvatarComponent,
    FeedAllRoomsVueComponent,
    InterventionDetailPanelComponent,
    InterventionDetailsPopupComponent,
    AddVacationPopupComponent,
    MoveInterventionPopupComponent,
    HoursPopupComponent,
    CreateCycleDialogComponent,
    NgxGaugeModule,
    RangeDatePickerModule,
    CodeRHBadgeComponent,
    PopupEditVacationComponent,
    LogsSidenavComponent,
    SpiderChartComponent,
    PopupRoleSkillDetailsComponent,
    FilterReasonMapsComponent,
    NgxMatSelectSearchModule,
    AdjustPlanningPopupComponent,
    PopupExportStaffComponent,
    MetricTileComponent,
    DocumentationDialogComponent,
    PopulationDetailsPopupComponent,
  ],
})
export class SharedModule {}
